import React from 'react'
import { connect } from 'react-redux'
import { nullDate, getListItems } from 'Tyan/public/utility'
import { hasChangedValues, getFormValue, changeItemsValue } from 'Tyan/public/utility/formValues'
class UseVacationInfoDiv extends React.Component {
    state = {
        changedValues基本信息: {},
    }
    componentDidMount = () => {
        const { id } = this.props
        this.doGetUseVacationInfo(id)
    }

    doGetUseVacationInfo = (id) => {
        const { taskName } = this.props
        Tyan.doPostEvent({
            event: 'GetUseVacationInfo',
            data: {
                id: id || 0,
                taskName
            },
            onEnd: ({ errorMessage, initValues基本信息, optionsParas }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    this.setState({ id, initValues基本信息, changedValues基本信息: {}, optionsParas })
                }
            }
        })
    }

    handlerSave = () => {
        const { id, onClose, onSave } = this.props
        const { changedValues基本信息 } = this.state
        Tyan.doPostEvent({
            event: 'SaveUseVacationInfo',
            data: {
                id, changedValues基本信息
            },
            onEnd: ({ errorMessage, id }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    Ext.toast('保存成功')
                    onClose && onClose()
                    onSave && onSave()
                }
            }
        })
    }

    handlerDelete = () => {
        const { onClose, onSave } = this.props
        const { id } = this.state
        Tyan.pubForm.showConfirm('确定要删除？', () =>
            Tyan.doPostEvent({
                event: 'DeleteUseVacationInfo',
                data: { id },
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                    }
                    else {
                        Ext.toast('删除成功')
                        onSave && onSave()
                        onClose && onClose()
                    }
                }
            }))
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    bSave = () => {
        return true
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }

    fieldset基本信息 = () => {
        return [
            { _text: '休假人员', minWidth: '95%', disabled: true },
            { _datetime: '开始时间', minWidth: '95%' },
            { _datetime: '结束时间', minWidth: '95%' },
            { _select: '职务代理人', minWidth: '95%' },
        ]
    }

    render() {
        const { showMessage: Message, showBody: Body, readOnly } = this.props
        const { errorMessage, id, initValues基本信息, } = this.state
        if (errorMessage) return Tyan.pubForm.showError(errorMessage)
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        const { 状态, 提交时间 } = initValues基本信息
        return <Body data={this} maxWidth="700"
            controls={
                readOnly ? [
                    { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose }
                ] : [
                    { _button: '保存', icon: 'save', handler: () => this.handlerSave(), disabled: !(this.bSave() && this.bChanged()), cdt: () => 状态 == '申请中' },
                    { _button: '删除', icon: 'trash-o', ui: 'action decline alt', handler: this.handlerDelete, cdt: () => id > 0 && 状态 == '申请中', disabled: this.bChanged(), },
                    { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: readOnly || 状态 !== '申请中' },

                ]
            }
        />
    }
}

export default connect()(UseVacationInfoDiv)